<div class="flex flex-col gap-4 p-4 h-full">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <mat-icon class="text-gray-500">people</mat-icon>
      <span class="font-medium">Consulta de Usuarios</span>
      @if (businessPartnersInfo().length > 0) {
        <span class="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-sm">
          {{ businessPartnersInfo().length }}
        </span>
      }
    </div>
    <button 
      mat-flat-button 
      color="primary" 
      (click)="openUserSelector()" 
      [disabled]="isLoading() || !(PERMISSIONS.USERS | hasPermission)">
      <mat-icon>search</mat-icon>
      Consultar Usuarios
    </button>
  </div>

  <!-- Loading -->
  @if (isLoading()) {
    <div class="flex justify-center p-8">
      <mat-spinner diameter="40" />
    </div>
  }

  <!-- Lista vacía -->
  @if (!isLoading() && businessPartnersInfo().length === 0) {
    <div class="flex flex-col items-center justify-center p-8 text-gray-500 border-2 border-dashed rounded-lg flex-1">
      <mat-icon class="!text-5xl !w-12 !h-12 mb-2">people</mat-icon>
      <p>Seleccione usuarios para ver sus rutas y viajes asignados</p>
      <button mat-stroked-button color="primary" class="mt-4" (click)="openUserSelector()" *canPermissionsOnly="PERMISSIONS.USERS">
        <mat-icon>search</mat-icon> Consultar Usuarios
      </button>
    </div>
  }

  <!-- SmartGrid de resultados -->
  @if (!isLoading() && businessPartnersInfo().length > 0) {
    <div class="flex-1 min-h-0">
      <app-smart-grid
        [data]="businessPartnersInfo()"
        [columnDefs]="columnDefs"
        [config]="gridConfig"
        [loading]="false">
      </app-smart-grid>
    </div>
  }
</div>
